/**
 * 聊天窗口
 * Bai.Zhiming
 * 2019-07-09
 */
angular.module("chatWindowModule", [
    "chartListModule",
    "chatDirectoryModule",
    "dialogBoxModule",
    'infoPanelModule',
    'dialogBoxServiceModule'
]).controller('chatWindowCtrl', ['$scope', 'imService', 'loginUser', '$timeout', '$element',
    function($scope, imService, loginUser, $timeout, $element) {
        initStatus();
        initData();
        /**
         * [close description] 关闭聊天窗口
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $scope.$root.chatWindowSwitch = false;
        };
        /**
         * [showChartList description] 打开聊天列表
         * @return {[type]} [description]
         */
        $scope.showChartList = function() {
            $scope.status.chartListLoad = true;
            $scope.status.chartListShow = true;
            $scope.status.chatDirectoryShow = false;
        };
        /**
         * [showChatDirectory description] 打开通讯录
         * @return {[type]} [description]
         */
        $scope.showChatDirectory = function() {
            $scope.status.chatDirectoryLoad = true;
            $scope.status.chatDirectoryShow = true;
            $scope.status.chartListShow = false;
        };
        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            let position = localStorage.getItem("imPosition");
            position = !position ? {} : JSON.parse(position);
            $scope.status = {
                chatWindowLoad: true,
                chartListLoad: true, //聊天列表是否加载
                chatDirectoryLoad: false, //聊天通讯录是否加载
                chartListShow: true, //聊天列表是否显示
                chatDirectoryShow: false, //聊天通讯录是否显示
                sessionMap: {}, //会话列表，用于加载对话框指令
                showSession: "", //当前显示的会话
                loginUser: loginUser, // 当前登录用户,
                selectedDirectoryUser: "", //选中的通讯录用户信息
                noSound: localStorage.getItem("imNoSound") == 'true' ? true : false, //关闭音效
                imPosition: {
                    top: position.top,
                    left: position.left,
                    width: position.width,
                    height: position.height
                },
                dialogBoxMap: { //通知滚动到最底部方法map

                }
            };
            $scope.$root.chatWindowSwitch = position.show;
            $scope.chartListFn = { //对话列表回调函数
                getSessionInfo(item) { //点击对话列表选项，获取会话信息
                    if (!item) {
                        $scope.status.showSession = '';
                        return
                    }
                    let id = item.Type == 1 ? item.To_Account : item.ToAccount;
                    if (!$scope.status.sessionMap[id]) {
                        $scope.status.sessionMap[id] = item;
                        $scope.status.dialogBoxMap[id] = {}
                        /*let $dialogBox;
                        if (item.Type == 1) {
                            $dialogBox = $(`<dialog-box-c2c ng-if="status.chartListLoad&&status.sessionMap[${id}]" fn="status.dialogBoxMap['${id}']" login-info="status.loginUser" session-info="status.sessionMap['${id}']" ng-show="status.chartListShow&&status.showSession=='${id}'"></dialog-box-c2c>`);
                        } else {
                            $dialogBox = $(`<dialog-box-group ng-if="status.chartListLoad&&status.sessionMap[${id}]" fn="status.dialogBoxMap['${id}']" login-info="status.loginUser" session-info="status.sessionMap['${id}']" ng-show="status.chartListShow&&status.showSession=='${id}'"></dialog-box-group>`);
                        }
                        $dialogBox = $compile($dialogBox)($scope);
                        $element.find(".right").append($dialogBox);*/
                    }
                    $scope.status.showSession = id;
                    if ($scope.status.dialogBoxMap[id].scrollBottom) {
                        $scope.status.dialogBoxMap[id].scrollBottom(); //点击进入时，有新消息，聊天窗口滚动到最底部
                    }
                    if ($scope.status.dialogBoxMap[id].showCallback) {
                        $scope.status.dialogBoxMap[id].showCallback();
                    }
                },
                /**
                 * [delSession description] 删除指定会话
                 * @param  {[type]} item [description] 会话信息
                 * @return {[type]}      [description]
                 */
                delSession(item) {
                    let id = item.Type == 1 ? item.To_Account : item.ToAccount;
                    $scope.status.showSession = id == $scope.status.showSession ? "" : $scope.status.showSession;
                    delete $scope.status.sessionMap[id];
                }
            };
            $scope.chartDirectoryFn = { //通讯录回调函数
                /**
                 * [selectInfo description] 选中了用户或者组织
                 * @param  {[type]} user [description] 用户或者组织信息信息
                 * @return {[type]}      [description]
                 */
                selectInfo(info) {
                    $scope.status.selectedDirectoryInfo = info;
                }
            };
            $scope.userInfoPanelFn = { //用户信息面板回调函数
                /**
                 * [selectedUser description] 选中了要发消息的用户
                 * @param  {[type]} user [description]
                 * @return {[type]}      [description]
                 */
                selectedUser(user) {
                    $scope.chartListFn.addSession(user, () => {
                        $scope.status.chartListShow = true;
                        $scope.status.chatDirectoryShow = false;
                    });
                },
                /**
                 * [selectedGroup description] 选中了要发送消息的群组
                 * @param  {[type]} group [description] 群组信息
                 * @return {[type]}       [description]
                 */
                selectedGroup(group) {
                    $scope.chartListFn.addSessionGroup(group, () => {
                        $scope.status.chartListShow = true;
                        $scope.status.chatDirectoryShow = false;
                    });
                }
            }
            watchWindowShow();
            dragAndDrop();
            imService.initShowBigImage($element, $scope);
        }
        /**
         * [soundSwitch description] 声音开关
         * @return {[type]} [description]
         */
        $scope.soundSwitch = function() {
            $scope.status.noSound = !$scope.status.noSound;
            localStorage.setItem("imNoSound", $scope.status.noSound);
        };
        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {}
        /**
         * [dragAndDrop description] 支持弹窗拖拽功能
         * @return {[type]} [description]
         */
        function dragAndDrop() {
            $timeout(() => {
                $element.find(".chat_window").draggable({
                    containment: "body",
                    handle: ".drag",
                    start(event, ui) {},
                    stop() {
                        saveWindowPosition();
                    }
                });
            }, 1000);
        }
        /**
         * [watchWindowShow description] 监听窗体显示信息
         * @return {[type]} [description]
         */
        function watchWindowShow() {
            $scope.$watch("$root.chatWindowSwitch", () => {
                let position = localStorage.getItem("imPosition");
                position = !position ? {} : JSON.parse(position);
                position.show = $scope.$root.chatWindowSwitch;
                localStorage.setItem('imPosition', JSON.stringify(position));
            });
        }
        /**
         * [saveWindowPosition description] 储存窗体位置
         * @param  {[type]} left [description]
         * @param  {[type]} top  [description]
         * @return {[type]}      [description]
         */
        function saveWindowPosition() {
            let boundingClientRect = $element.find(".chat_window")[0].getBoundingClientRect();
            let position = localStorage.getItem("imPosition");
            position = !position ? {} : JSON.parse(position);
            let imPosition = {
                left: boundingClientRect.left + "px",
                top: boundingClientRect.top + "px",
                width: boundingClientRect.width + "px",
                height: boundingClientRect.height + "px"
            };
            $scope.status.imPosition = angular.copy(imPosition);
            position = angular.extend(position, imPosition);
            localStorage.setItem('imPosition', JSON.stringify(position));
        }
        /**
         * [resizerInfo description] 接收重置信息
         * @param  {[type]} resizerInfo [description] 重置信息
         * @return {[type]}             [description]
         */
        $scope.resizerInfo = function(resizerInfo) {
            if (!$scope.$root.chatWindowSwitch) return;
            saveWindowPosition();
        }
    }
]);